import type { RouteRecordRaw, Router } from 'vue-router'

const LawyerRequestRegistrationRoutes: RouteRecordRaw = {
  path: '/registration/lawyerRequest',
  name: 'LawyerRequestModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'LawyerRequestMainRoute',
      component: () => import('./views/LawyerRequestView.vue'),
      meta: {
        title: 'lawyerRequest.lawyerRequest',
      },
    },
    {
      path: 'create',
      name: 'LawyerRequestCreateRoute',
      component: () => import('./views/LawyerRequestUpsertView.vue'),
      meta: {
        title: 'lawyerRequest.createLawyerRequest',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:lawyerRequestId',
      name: 'LawyerRequestEditRoute',
      component: () => import('./views/LawyerRequestUpsertView.vue'),
      meta: {
        title: 'lawyerRequest.editLawyerRequest',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:lawyerRequestId',
      name: 'ViewLawyerRequestRoute',
      component: () => import('./views/SingleLawyerRequestView.vue'),
      meta: {
        title: 'lawyerRequest.viewLawyerRequest',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(LawyerRequestRegistrationRoutes)
}
